export const DBI_TOPCHARTS = 'dbiTopcharts';

const MonetizationModel = {
  namespace: DBI_TOPCHARTS,
  state: {
    /** Active, UsersRevenue, Downloads三个榜单如果游戏有勾选则切换标签时继承 */
    activeUserGameList: [],
    /** 用于详情页头部feedback参数提供页面打点信息 */
    activedPageLogMes: null,
    appIdsBackup: [], // 上一个页面存的appid
    ifUnifiedGo: false, // 判断是否是游戏UnifiedId切换游戏，否则后退退回原链接
    activedPageInfo: '', // 每次打点记录当前访问的游戏详情页一级和二级菜单
    // 游戏详情页feedback需要使用到的，记录筛选器选中的appid
    selectedDemographicsAppid: '',
    lowerGameTime: [], // 下架的时间
    islowerGame: false, // 是否有下架时间的游戏
    ieggGenreTotal: [],
    annieGenreTotal: [],
    // 是否首次访问榜单落地页，用于在榜单落地页展示不同的提示交互，首次访问榜单落地页时，强制出现提示，非首次访问时，hover出现提示
    isFirstAccess: false,
    /** overview卡片数据*/
    detailIndex: [],
    /** 筛选器数据继承*/
    timeType: '',
    saveDateType: '', // 保留最后一次调用baseinfo后得到的默认时间粒度
    regionType: '',
    regionTypeOverview: '', // 从overview跳转继承的国家地区类型
    regions: [],
    regionsOverview: '', // 从overview跳转继承的国家地区
    regionTypeRetention: '', // Retention继承的国家地区类型
    regionsRetention: '', // Retention继承的国家地区
    regionsTypeRetentionApi: 'region',
    marketsRetentionApi: ['global'],
    markets: [], // 用于留存继承
    segment: '',
    platform: [],
    startDate: '',
    endDate: '',
    device: [],
    physicalRevenueDevice: [],
    japanSalesDevice: [],
    dataSource: '',
    isOverviewFirst: true, // 是否是第一次访问详情overview
    appIdsSelected: [], // 当前游戏appid
    activeTab: '', // stats页面目前展示页签
    isCalibrated: false, // 判断是否为校准游戏,
    msCountry: [], // Mscience指标有数据的国家（用于pc、console详情页下载，判断是否禁用下载指标）
    msCountryStr: '', // msCountry的markets(不包含region的)。按xx,xx,xx拼接的字符串，用于禁用展示hover提示
    jumpFromPage: '', // 榜单/下钻跳转到详情（详情页用来判断是否要往前推时间段）使用bool值，因为跳时为true，跳到对应页面后使用完让其变为false
    isOperation: false, // 是否操作过 stats
    baseReleaseTime: '',
    baseReleaseMonth: '',
    baseReleaseWeek: '',
    releaseDatesByPlatform: '',
    jpnSalesMaxdate: '',
    jpnSalesMindate: '',
    isHasJapanSalesTop: false,

    // 以下用于从榜单跳转过来继承，只继承刚跳转进来那一次，后面恢复默认
    ifFromTopCharts: false, // 从榜单跳转过来的参数只调一次，以这个为判断
    retentionDetailOptionSelf: ['D2', 'D3', 'D7'],
    timeTypeOverview: '', // 从overview跳转继承的时间粒度
    isFirstStoreRank: true, // 判断是否第一次访问从榜单跳转详情storerank
    // store rank榜单页时间粒度，目前有Day、Month两种
    storerankDateType: 'Day',
    // store rank榜单页 月粒度下的时间
    storerankDate: '',
    // store rank榜单页 日粒度下的开始时间
    storerankStartDate: '',
    // store rank榜单页 日粒度下的结束时间
    storerankEndDate: '',
    storerankMarkets: [],
    storerankShopName: '',
    consoleStorerankPlatForm: '',
    consoleStorerankRankType: '',
    regionTypeForMau: 'region',
    regionValueForMau: ['global'],
    marketsValueForMau: ['global'],
    digRevRegions: ['global'], // StatsDigitalRevnue只继承跳转的和自己的
    digRevRegionType: 'region',
    segmentForDigital: 'All',
    deviceForDigital: ['All'],
    /** Streaming */
    streamPlatform: [],
    streamStartdate: '',
    streamEnddate: '',
    streamPerios: 'day',
    isFromJapanSalesTop: false,
    startDateJapanSalesTop: '',
    endDateJapanSalesTop: '',
    demographicsAppid: '',
    overlapAnalysisAppid: '',
    demographicsFilter: {},
    earliestDate: {},
    earliestCurDay: '',
    isNeedEarliestUpdate: true,
    urlParams: {},
    metricValue: '',
    metricValueListObj: {}, // 用于榜单metricTable的指标筛选器继承到详情页
    metricValueRangeTime: {}, // 用于榜单metricTable的默认有数据时间继承到详情页
    metricCurName: '',
    isShowActiveUsersTip: true,
    isShowActiveUsersTopChartsTip: true,
    isShowRevenueDownloadsTip: true,
    isShowCommonDeliveryTip: true,
    isShowFollowingDeliveryTip: true,
    ifShowBaseReleaseTime: false,
    selectedTimeShortcutType: '',
    steamTagsLocaleTextMap: {},
    gameModeLocaleTextMap: {},
    gameEngineLocaleTextMap: {},
    queryDefinition: { filterLoading: true },
    topchartJumpParam: {},
  },

  reducers: {
    setActiveUserGameList(state: any, action: any) {
      return {
        ...state,
        activeUserGameList: action.payload,
      };
    },
    setActivedPageLogMes(state: any, action: any) {
      return {
        ...state,
        activedPageLogMes: action.payload,
      };
    },
    setAppIdsBackup(state: any, action: any) {
      return {
        ...state,
        appIdsBackup: action.payload,
      };
    },
    setIfUnifiedGo(state: any, action: any) {
      return {
        ...state,
        ifUnifiedGo: action.payload,
      };
    },
    setActivedPageInfo(state: any, action: any) {
      return {
        ...state,
        activedPageInfo: action.payload,
      };
    },
    setSelectedDemographicsAppid(state: any, action: any) {
      return {
        ...state,
        selectedDemographicsAppid: action.payload,
      };
    },
    setLowerGameTime(state: any, action: any) {
      return {
        ...state,
        lowerGameTime: action.payload,
      };
    },
    setIslowerGame(state: any, action: any) {
      return {
        ...state,
        islowerGame: action.payload,
      };
    },
    setIeggGenreTotal(state: any, action: any) {
      return {
        ...state,
        ieggGenreTotal: action.payload,
      };
    },
    setAnnieGenreTotal(state: any, action: any) {
      return {
        ...state,
        annieGenreTotal: action.payload,
      };
    },
    setTimeTypeOverview(state: any, action: any) {
      return {
        ...state,
        timeTypeOverview: action.payload,
      };
    },
    setTimeType(state: any, action: any) {
      return {
        ...state,
        timeType: action.payload,
      };
    },
    setIsFirstStoreRank(state: any, action: any) {
      return {
        ...state,
        isFirstStoreRank: action?.payload,
      };
    },
    setRegionTypeOverview(state: any, action: any) {
      return {
        ...state,
        regionTypeOverview: action.payload,
      };
    },
    setRegionsOverview(state: any, action: any) {
      return {
        ...state,
        regionsOverview: action.payload,
      };
    },
    setIsOverviewFirst(state: any, action: any) {
      return {
        ...state,
        isOverviewFirst: action.payload,
      };
    },
    setBaseReleaseTime(state: any, action: any) {
      return {
        ...state,
        baseReleaseTime: action.payload,
      };
    },
    setBaseReleaseMonth(state: any, action: any) {
      return {
        ...state,
        baseReleaseMonth: action.payload,
      };
    },
    setBaseReleaseWeek(state: any, action: any) {
      return {
        ...state,
        baseReleaseWeek: action.payload,
      };
    },
    setReleaseDatesByPlatform(state: any, action: any) {
      return {
        ...state,
        releaseDatesByPlatform: action.payload,
      };
    },
    setAppIdsSelected(state: any, action: any) {
      return {
        ...state,
        appIdsSelected: action.payload,
      };
    },
    setEarliestDate(state: any, action: any) {
      return {
        ...state,
        earliestDate: action.payload,
      };
    },
    setEarliestCurDay(state: any, action: any) {
      return {
        ...state,
        earliestCurDay: action.payload,
      };
    },
    setIsNeedEarliestUpdate(state: any, action: any) {
      return {
        ...state,
        isNeedEarliestUpdate: action.payload,
      };
    },
    setIsShowActiveUsersTip(state: any, action: any) {
      return {
        ...state,
        isShowActiveUsersTip: action.payload,
      };
    },
    setIsShowActiveUsersTopChartsTip(state: any, action: any) {
      return {
        ...state,
        isShowActiveUsersTopChartsTip: action.payload,
      };
    },
    setIsShowRevenueDownloadsTip(state: any, action: any) {
      return {
        ...state,
        isShowRevenueDownloadsTip: action.payload,
      };
    },
    setIsShowCommonDeliveryTip(state: any, action: any) {
      return {
        ...state,
        isShowCommonDeliveryTip: action.payload,
      };
    },
    setIsShowFollowingDeliveryTip(state: any, action: any) {
      return {
        ...state,
        isShowFollowingDeliveryTip: action.payload,
      };
    },
    setUrlParams(state: any, action: any) {
      return {
        ...state,
        urlParams: action.payload,
      };
    },
    setMetricValue(state: any, action: any) {
      return {
        ...state,
        metricValue: action.payload,
      };
    },
    setMetricValueListObj(state: any, action: any) {
      return {
        ...state,
        metricValueListObj: action.payload,
      };
    },
    setMetricValueRangeTime(state: any, action: any) {
      return {
        ...state,
        metricValueRangeTime: action.payload,
      };
    },
    setMetricCurName(state: any, action: any) {
      return {
        ...state,
        metricCurName: action.payload,
      };
    },
    setJpnSalesMaxdate(state: any, action: any) {
      return {
        ...state,
        jpnSalesMaxdate: action.payload,
      };
    },
    setJpnSalesMindate(state: any, action: any) {
      return {
        ...state,
        jpnSalesMindate: action.payload,
      };
    },
    setIsHasJapanSalesTop(state: any, action: any) {
      return {
        ...state,
        isHasJapanSalesTop: action.payload,
      };
    },
    setDemographicsAppid(state: any, action: any) {
      return {
        ...state,
        demographicsAppid: action.payload,
      };
    },
    setOverlapAnalysisAppid(state: any, action: any) {
      return {
        ...state,
        overlapAnalysisAppid: action.payload,
      };
    },
    setJumpFromPage(state: any, action: any) {
      return {
        ...state,
        jumpFromPage: action.payload,
      };
    },
    setIfShowBaseReleaseTime(state: any, action: any) {
      return {
        ...state,
        ifShowBaseReleaseTime: action.payload,
      };
    },
    setSelectedTimeShortcutType(state: any, action: any) {
      return {
        ...state,
        selectedTimeShortcutType: action?.payload || '',
      };
    },
    setSteamTagsLocalTextMap(state: any, action: any) {
      return {
        ...state,
        steamTagsLocaleTextMap: action.payload,
      };
    },
    setGameModeLocalTextMap(state: any, action: any) {
      return {
        ...state,
        gameModeLocaleTextMap: action.payload,
      };
    },
    setGameEngineLocaleTextMap(state: any, action: any) {
      return {
        ...state,
        gameEngineLocaleTextMap: action.payload,
      };
    },
    setQueryDefinition(state: any, action: any) {
      return {
        ...state,
        queryDefinition: action.payload,
      };
    },
    setTopchartJumpParam(state: any, action: any) {
      return {
        ...state,
        topchartJumpParam: action.payload,
      };
    },
    setIsOperation(state: any, action: any) {
      return {
        ...state,
        isOperation: action.payload,
      };
    },
  },
};

export default MonetizationModel;
